import { render, staticRenderFns } from "./GalleryModalTabs.vue?vue&type=template&id=7a2d5edc&scoped=true&"
import script from "./GalleryModalTabs.vue?vue&type=script&lang=js&"
export * from "./GalleryModalTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2d5edc",
  null
  
)

export default component.exports